/* import __COLOCATED_TEMPLATE__ from './radio-form.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();